export const makeBaseImagePath = (image: string | undefined) => {
  if (!image) {
    return '';
  }

  return `${process.env.GATSBY_API_BASE_URL}/api/v1/assets/files/${image}`;
};
